"use client";

import AppHero from "src/components/Common/AppHero";
import TechStats from "src/components/Common/TechStats";
import FAQSection from "src/components/Common/FAQSection";
import WhyChooseUs from "src/components/Common/WhyChooseUs";
import TechsSection from "src/components/Common/TechsSection";
import NavigationSection from "src/components/Common/NavigationSection";
import ProcessStepsSection from "src/components/Common/ProcessStepsSection";
import PagesServicesSection from "src/components/Common/PagesServicesSection";
import {
  webAppServices,
  webAppFaqs,
  webAppHeroData,
  flutterStatsData,
  flutterTechnologiesData,
  webSolutionsAndProcessData,
  webPortfolioData,
  webAppAboutData,
} from "src/utils/mock/webAppData";
import CommonContactSection from "src/components/Common/CommonContactSection";

export default function WebAppDevelopment({ caseStudies }) {
  const liveProjects = caseStudies?.projects?.liveProjects || [];

  const webProjects = liveProjects.filter((project) => {
    const isWebPlatform = project.platforms?.toLowerCase().includes("web");
    return isWebPlatform;
  });

  const filteredData = caseStudies
    ? {
        ...webPortfolioData,
        projects: {
          liveProjects: webProjects,
        },
      }
    : webPortfolioData;
  const techIcons = filteredData?.projects?.liveProjects[0]?.technologies;
  return (
    <div>
      <AppHero heroData={webAppHeroData} />
      <TechStats stats={flutterStatsData} />
      <NavigationSection data={webAppServices} leftHeading="Complete Web " rightHeading=" Application Solutions" />
      <WhyChooseUs data={webSolutionsAndProcessData} />

      <section className="w-full bg-background-primary text-white px-6! md:px-12! relative overflow-hidden font-sans">
        <div className="absolute top-1/4 right-0 w-[500px] h-[500px] bg-purple-900/10 blur-[150px] -z-10 rounded-full" />
        <div className="absolute bottom-1/4 left-0 w-[500px] h-[500px] bg-blue-950/20 blur-[150px] -z-10 rounded-full" />

        <div className="max-w-8xl mx-auto!">
          <PagesServicesSection data={filteredData} />
          <ProcessStepsSection data={flutterTechnologiesData} techIcons={techIcons} />
          <TechsSection mainTitle="About Web App Development" sections={webAppAboutData} />
        </div>
      </section>
      <FAQSection faqs={webAppFaqs} />
      <CommonContactSection />
    </div>
  );
}
